import { useState } from 'react';
import { siteInfo } from '@/mocks/home';

export default function Hero() {
  const [imgError, setImgError] = useState(false);

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        {!imgError && (
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20cozy%20bedroom%20at%20night%20with%20soft%20ambient%20lighting%2C%20a%20person%20relaxing%20in%20bed%20watching%20a%20glowing%20screen%20with%20colorful%20cinematic%20visuals%2C%20comfortable%20pillows%20and%20blankets%2C%20atmospheric%20mood%20lighting%20with%20bokeh%20effect%2C%20artistic%20composition%2C%20warm%20golden%20and%20amber%20tones%2C%20high%20detail%20editorial%20photography%20style%2C%20cinema%20inspired%20aesthetic&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
            alt="被窝影院 - 躺在被窝里追剧"
            className="w-full h-full object-cover"
            onError={() => setImgError(true)}
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-medium rounded-full bg-accent-500/90 text-background-50 mb-5 whitespace-nowrap">
              {siteInfo.tag}
            </span>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight">
              {siteInfo.name}
              <br />
              <span className="text-accent-300">免费电视剧大全，全集在线看</span>
            </h1>

            <p className="mt-4 text-sm md:text-base text-background-50/80 font-heading text-lg md:text-xl">
              {siteInfo.slogan}
            </p>

            <div className="mt-6 space-y-2">
              <p className="text-sm md:text-base text-background-50/70 leading-relaxed max-w-xl mx-auto lg:mx-0">
                {siteInfo.description}
              </p>
              <p className="text-sm md:text-base text-background-50/60 leading-relaxed max-w-xl mx-auto lg:mx-0">
                {siteInfo.description2}
              </p>
            </div>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6">
              {siteInfo.stats.map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-accent-300 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-background-50/60 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="px-8 py-3 text-sm font-medium bg-primary-500 text-background-50 rounded-full whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-200"
              >
                开始追剧
              </a>
              <a
                href="#ranking"
                className="px-8 py-3 text-sm font-medium bg-background-50/15 text-background-50 border border-background-50/30 rounded-full whitespace-nowrap cursor-pointer hover:bg-background-50/25 transition-all duration-200"
              >
                热门榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20collage%20of%20Chinese%20TV%20drama%20scenes%2C%20ancient%20costume%20drama%20warriors%2C%20modern%20crime%20thriller%20cityscape%2C%20romantic%20period%20drama%20couple%2C%20sci-fi%20space%20visuals%2C%20warm%20cinematic%20color%20grading%2C%20dramatic%20lighting%2C%20movie%20poster%20style%20composition%2C%20rich%20amber%20and%20crimson%20tones&width=800&height=600&seq=hero-visual-2026&orientation=landscape"
                alt="被窝影院 - 热播剧集主视觉"
                className="w-full h-auto rounded-2xl"
                onError={(e) => {
                  const el = e.currentTarget;
                  el.style.display = 'none';
                }}
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4 md:p-6">
                <div className="flex items-center gap-2">
                  <div className="w-2.5 h-2.5 rounded-full bg-accent-400 animate-pulse"></div>
                  <span className="text-xs text-background-50/90 font-medium">实时热播中 · 每日更新</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}